import PropTypes from 'prop-types';
import Divider from '@mui/material/Divider';

// project imports
import DrawerHeaderStyled from './DrawerHeaderStyled';
import Logo from 'components/logo';

// ==============================|| DRAWER HEADER ||============================== //

export default function DrawerHeader({ open }) {
  return (
    <>
      <DrawerHeaderStyled open={open}>
        <Logo isIcon={!open} sx={{ width: open ? 'auto' : 35, height: 35 }} />
      </DrawerHeaderStyled>
      <Divider sx={{ mx: open ? 2 : 1.25 }} />
    </>
  );
}

DrawerHeader.propTypes = { open: PropTypes.bool };
